/**
 * Identité du texte des conditions générales d'utilisation.
 *
 * ── Deux constantes, volontairement ─────────────────────────────────────────
 *
 * La même valeur existe côté API (`src/common/legal/cgu.ts`). Ce n'est pas un
 * oubli de factorisation :
 *
 *   - le front doit pouvoir afficher la version sans appel réseau, y compris
 *     sur `/cgu` qui est une page publique consultable sans session ;
 *   - le back ne doit JAMAIS enregistrer une version fournie par le client.
 *     S'il le faisait, n'importe qui prouverait avoir accepté n'importe quel
 *     texte. La version écrite en base vient donc toujours de la constante
 *     serveur, et le formulaire n'envoie qu'un booléen.
 *
 * Les deux doivent rester égales : sinon on enregistre « a accepté la version
 * X » à quelqu'un à qui on a montré la version Y. Rien ne le signalerait à
 * l'exécution — c'est le test `cgu.spec.ts` de l'API qui compare les deux
 * fichiers et échoue en cas de dérive.
 *
 * ── À faire à chaque modification de fond du texte ──────────────────────────
 *
 * 1. Modifier `src/app/cgu/page.tsx`.
 * 2. Mettre à jour `CGU_VERSION` ci-dessous.
 * 3. Reporter LA MÊME valeur dans `pharmaworkspace-api/src/common/legal/cgu.ts`.
 *
 * Une révision de fond ne vaut pas pour les comptes qui ont accepté la version
 * précédente : leur acceptation reste rattachée à l'ancienne. Les relancer est
 * un écran à part, qui n'existe pas encore.
 */
export const CGU_VERSION = "2026-08-20";

/** La même date, telle qu'on la lit — en-tête du document et mentions de bas de formulaire. */
export const CGU_VERSION_LABEL = "20 août 2026";
